import ReactiveButton from 'reactive-button';

interface RefreshOnClick {
  requestState: string,
  onClickHandler: () => void
}

const RefreshButton: React.FC<RefreshOnClick> = ({ requestState, onClickHandler }) => {

  return (
    <>
      <ReactiveButton
        buttonState={requestState}
        onClick={onClickHandler}
        color={'yellow'}
        idleText={'Refresh'}
        loadingText={'Loading'}
        errorText={'Error'}
        type={'button'}
        style={{ borderRadius: '20px', color: 'white', border: '3px solid #AF975A' }}
        outline={true}
        shadow={false}
        rounded={false}
        size={'normal'}
        block={false}
        messageDuration={2000}
        disabled={false}
        buttonRef={null}
        width={null}
        height={null}
        animation={true}
      />
    </>
  );
}

export default RefreshButton;